import ResourceService from "./resource.service";

class UsersService extends ResourceService {
  static get resource() {
    return "admin/users";
  }
}

export default UsersService;
